import { APPLIANCE_METADATA, COUNTRIES } from './constants';

/**
 * MaDaNRG Deterministic Solar Engine
 * Uses the structured PSH dataset for conservative, installer-grade sizing.
 */
export const calculateRecommendation = (data) => {
  const countryInfo = COUNTRIES.find(c => c.name === data.country) || COUNTRIES[0];
  const symbol = countryInfo.symbol;
  const psh = data.peak_sun_hours || 4.0; // PSH retrieved from dataset

  let totalDailyWh = 0;
  let peakWattsRunning = 0;

  // Step 1: Daily Energy Consumption (W * Qty * Hours)
  data.appliances.forEach(app => {
    const meta = APPLIANCE_METADATA[app];
    if (meta) {
      const countVal = data.appliance_count[app];
      const count = countVal === '3+' ? 4 : (parseInt(countVal) || 1);
      const hours = parseInt(data.appliance_hours[app]) || 0;
      
      totalDailyWh += (meta.watts * count * hours);
      peakWattsRunning += (meta.watts * count);
    }
  });

  // Step 3: System Loss Factor (0.8 Efficiency)
  const adjustedLoad = totalDailyWh / 0.8;

  // Step 4: Solar Sizing (W) = Adjusted Load / PSH
  const solarWatts = adjustedLoad / psh;

  // Step 5: Battery Sizing (Wh) = Total Load * 1 Day Backup / 0.9 DoD
  const batteryWh = totalDailyWh / 0.9;

  // Step 6: Inverter Sizing (W) = Peak Running Watts * 1.25 Safety
  const inverterWatts = peakWattsRunning * 1.25;

  // Cost Estimation Logic
  const exchangeRate = data.country === 'Nigeria' ? 1550 : (data.country === 'South Africa' ? 19 : 1);
  const baseUSD = (solarWatts * 1.1) + (batteryWh * 0.45) + (inverterWatts * 0.3);
  const min = Math.round(baseUSD * 0.9 * exchangeRate);
  const max = Math.round(baseUSD * 1.3 * exchangeRate);

  return {
    systemType: totalDailyWh > 10000 ? "Advanced Hybrid Solar Solution" : "Smart Home Solar Setup",
    why: `In ${data.city}, ${data.country}, your energy needs are best met with a conservative design focused on ${psh} peak sun hours.`,
    city: data.city,
    country: data.country,
    peakSunHours: psh,
    metrics: {
      dailyConsumption: Math.round(totalDailyWh),
      solarSize: Math.round(solarWatts),
      batterySize: Math.round(batteryWh),
      inverterSize: Math.round(inverterWatts)
    },
    costRange: { min, max, symbol },
    savings: "ROI in 3-5 Years"
  };
};